import { TopMySpotItemFragment } from 'generated/graphql'
import { searchHotelFormDefaultData } from 'helper/searchHotelParams'
import { QueryHelper } from 'lib/query/helper'
import { QueryString } from 'types/queryString'

type MapSpot = Pick<TopMySpotItemFragment, 'title' | 'coordinate'>

export type MapSpotFallbackSearchCondition = {
  lat: string
  lon: string
  spotTitle: string
  radiusKm: string
  checkin: string
  checkout: string
  occupancies: string[]
}

export type ParsedMapSpotFallbackSearchCondition = {
  spotTitle: string
  coordinate: {
    latitude: number
    longitude: number
  }
  radiusKm: number
  checkin: string
  checkout: string
  occupancies: ReturnType<typeof searchHotelFormDefaultData.occupancies>
}

const isFiniteNumber = (value: number | undefined): value is number => value !== undefined && Number.isFinite(value)

export const buildMapSpotFallbackSearchCondition = (spot: MapSpot): MapSpotFallbackSearchCondition => ({
  lat: spot.coordinate.latitude.toString(),
  lon: spot.coordinate.longitude.toString(),
  spotTitle: spot.title,
  radiusKm: '1',
  checkin: searchHotelFormDefaultData.checkin(),
  checkout: searchHotelFormDefaultData.checkout(),
  occupancies: QueryHelper.buildOccupanciesParams(searchHotelFormDefaultData.occupancies()),
})

export const parseMapSpotFallbackSearchCondition = (query: QueryString): ParsedMapSpotFallbackSearchCondition | undefined => {
  const lat = QueryHelper.getNumber(query.lat)
  const lon = QueryHelper.getNumber(query.lon)
  const radiusKm = QueryHelper.getNumber(query.radiusKm)
  const spotTitle = QueryHelper.getStringOrFirst(query.spotTitle)
  const checkin = QueryHelper.getStringOrFirst(query.checkin)
  const checkout = QueryHelper.getStringOrFirst(query.checkout)
  const occupancies = QueryHelper.getAsOccupancies(query.occupancies)

  if (!isFiniteNumber(lat) || !isFiniteNumber(lon) || !isFiniteNumber(radiusKm) || radiusKm <= 0 || !spotTitle) return
  if (!checkin || !checkout || !occupancies) return

  return {
    spotTitle,
    coordinate: { latitude: lat, longitude: lon },
    radiusKm,
    checkin,
    checkout,
    occupancies,
  }
}
